
import { EnhancedButton } from "@/components/ui/enhanced-button";
import { ArrowRight, Shield, Award, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  console.log('Hero component is rendering');
  const navigate = useNavigate();

  const handleDemoClick = () => {
    const element = document.getElementById("demo-video");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      // Set focus to the section for keyboard users
      element.tabIndex = -1;
      element.focus({ preventScroll: true });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-900 to-black overflow-hidden">
      {/* Background overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40 z-10"></div>
      
      {/* Subtle animated background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" role="banner">
        {/* Executive positioning badge */}
        <div className="inline-flex items-center rounded-full px-6 py-3 text-sm font-semibold bg-white/95 text-gray-900 ring-1 ring-white/20 mb-8 backdrop-blur-sm shadow-lg">
          <Award className="h-4 w-4 mr-2 text-blue-600" />
          Executive Strategy Platform
        </div>
        
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold tracking-tight mb-8 leading-tight">
          <span className="block text-white mb-2">
            Transform Strategy into
          </span>
          <span className="block bg-gradient-to-r from-blue-400 via-blue-300 to-white bg-clip-text text-transparent">
            Competitive Advantage
          </span>
        </h1>
        
        <p className="text-xl sm:text-2xl text-gray-200 max-w-4xl mx-auto mb-8 leading-relaxed font-light">
          The strategic planning platform built for executives who demand results. 
          <span className="block mt-2 text-blue-200">AI-powered insights, enterprise security, measurable outcomes.</span>
        </p>
        
        {/* Key value props */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-12 text-gray-300">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/20 rounded-lg">
              <TrendingUp className="h-5 w-5 text-blue-400" />
            </div>
            <span className="font-medium">Streamlined Workflows</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-500/20 rounded-lg">
              <Shield className="h-5 w-5 text-green-400" />
            </div>
            <span className="font-medium">Enterprise Security</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-md mx-auto mb-8">
          <EnhancedButton
            size="xl"
            className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-2xl hover:shadow-blue-500/25 hover:scale-105 transition-all duration-300 min-h-[56px] font-semibold text-lg border-0"
            onClick={() => navigate("/auth?mode=signup")}
            aria-label="Start your strategic transformation"
          >
            Start Free Trial
            <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
          </EnhancedButton>
          <EnhancedButton
            size="xl"
            variant="outline"
            className="w-full sm:w-auto bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/50 backdrop-blur-sm min-h-[56px] font-medium text-lg transition-all duration-300"
            onClick={handleDemoClick}
            aria-label="Watch product demo"
          >
            Watch Demo
          </EnhancedButton>
        </div>
        
        <p className="text-sm text-gray-400 font-light">
          No credit card required • 24-hour full access • Enterprise setup available
        </p>
      </div>
    </section>
  );
};

export default Hero;
